import {t} from 'i18next';
import {ServiceStatus} from '../../../../PRMGApiClient';

export const createEditVehicleTabs = [
  t('Key specifications'),
  t('Photos'),
  t('Overview'),
  t('Service data'),
  t('Parking spot attributes'),
  t('Car equipment'),
  t('Files'),
  t('Additional photos'),
];

export const STATUS_OPTIONS = [
  {
    value: ServiceStatus.Planned,
    label: t('Planned'),
  },
  {
    value: ServiceStatus.InProgress,
    label: t('In progress'),
  },
  {
    value: ServiceStatus.Completed,
    label: t('Completed'),
  },
];
